var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isHeader)?_c('th',{staticClass:"b-r-1"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_c('span',{staticClass:"f-s-14"},[_c('b',[_vm._v(_vm._s(_vm.rowData.inspection.nextService))])])}
var staticRenderFns = []

export { render, staticRenderFns }